import React, { FC } from 'react';

interface IWarningIcon {}

export const WarningIcon: FC<IWarningIcon> = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.8076 3.12342C6.78334 1.43803 9.21668 1.43803 10.1924 3.12341L14.2881 10.1978C15.2659 11.8867 14.0472 14.0005 12.0957 14.0005H3.90431C1.9528 14.0005 0.734118 11.8867 1.7119 10.1978L5.8076 3.12342ZM8.00001 5.33366C8.36821 5.33366 8.66668 5.63214 8.66668 6.00032V8.66699C8.66668 9.03519 8.36821 9.33366 8.00001 9.33366C7.63181 9.33366 7.33334 9.03519 7.33334 8.66699V6.00032C7.33334 5.63214 7.63181 5.33366 8.00001 5.33366ZM8.66668 10.667C8.66668 11.0352 8.36821 11.3337 8.00001 11.3337C7.63181 11.3337 7.33334 11.0352 7.33334 10.667C7.33334 10.2988 7.63181 10.0003 8.00001 10.0003C8.36821 10.0003 8.66668 10.2988 8.66668 10.667Z"
        fill="#D42E1C"
      />
    </svg>
  );
};
